import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-ui-tab" }
const _hoisted_2 = { class: "tab__header" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "tab__body" }
const _hoisted_5 = { class: "tab__body--icon" }
const _hoisted_6 = { class: "tab__body--label" }
const _hoisted_7 = { class: "tab__search" }
const _hoisted_8 = { class: "list__header" }
const _hoisted_9 = { class: "list__head" }
const _hoisted_10 = { class: "main__header" }
const _hoisted_11 = { class: "main__header--title" }
const _hoisted_12 = { class: "icon" }
const _hoisted_13 = { class: "main__header--action" }
const _hoisted_14 = { class: "child__list" }
const _hoisted_15 = { class: "child__list--item" }
const _hoisted_16 = { class: "list__head" }
const _hoisted_17 = { class: "main__header" }
const _hoisted_18 = { class: "main__header--title" }
const _hoisted_19 = { class: "icon" }
const _hoisted_20 = { class: "main__header--action" }
const _hoisted_21 = { class: "child__list" }
const _hoisted_22 = { class: "child__list--item" }
const _hoisted_23 = { class: "list__head" }
const _hoisted_24 = { class: "main__header" }
const _hoisted_25 = { class: "main__header--title" }
const _hoisted_26 = { class: "icon" }
const _hoisted_27 = { class: "main__header--action" }
const _hoisted_28 = { class: "child__list" }
const _hoisted_29 = { class: "child__list--item" }

import {LayersThree01, Users03, MessageDotsCircle, AlertTriangle, ArrowNarrowRight} from "utruckin-icons";
import {Component, ref} from "vue";
import {useSearchStore} from "@/features/search/search.store";

interface ITab {
  label: string;
  value: number;
  icon: Component
}


export default /*@__PURE__*/_defineComponent({
  __name: 'globalSearchTab',
  setup(__props) {

const searchStore = useSearchStore();

const activeTab = ref<number>(0);
const tabs = ref<ITab[]>([
  {
    value: 0,
    label: 'All',
    icon: LayersThree01
  },
  {
    value: 1,
    label: 'Users',
    icon: Users03
  },
  {
    value: 2,
    label: 'Message',
    icon: MessageDotsCircle
  },
  {
    value: 3,
    label: 'Error messages',
    icon: AlertTriangle
  },
])

const change = (tab: ITab) => {
  activeTab.value = tab.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["tab", tab.value == activeTab.value ? 'active' : '']),
          key: index,
          onClick: ($event: any) => (change(tab))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(tab.icon), {
                class: "icon",
                size: 16
              }))
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(tab.label), 1)
          ])
        ], 10, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_unref(Users03), { size: 16 })
              ]),
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "headline" }, "Users", -1))
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_unref(ArrowNarrowRight), { size: 16 })
            ])
          ]),
          _createElementVNode("ul", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchStore).smartSearchData?.chats, (item) => {
              return (_openBlock(), _createElementBlock("li", _hoisted_15, _toDisplayString(item.title), 1))
            }), 256))
          ])
        ]),
        _createElementVNode("li", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_unref(MessageDotsCircle), { size: 16 })
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "headline" }, "Message", -1))
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_unref(ArrowNarrowRight), { size: 16 })
            ])
          ]),
          _createElementVNode("ul", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchStore).smartSearchData?.messages, (item) => {
              return (_openBlock(), _createElementBlock("li", _hoisted_22, _toDisplayString(item.text), 1))
            }), 256))
          ])
        ]),
        _createElementVNode("li", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_unref(AlertTriangle), { size: 16 })
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "headline" }, "Error messages", -1))
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_unref(ArrowNarrowRight), { size: 16 })
            ])
          ]),
          _createElementVNode("ul", _hoisted_28, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchStore).smartSearchData?.errors, (item) => {
              return (_openBlock(), _createElementBlock("li", _hoisted_29, _toDisplayString(item.message_text_preview), 1))
            }), 256))
          ])
        ])
      ])
    ])
  ]))
}
}

})